import Card from "@/atoms/CardKeyWorkers";
import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";
import Medical from "@/public/key-workers/medical.svg?url";
import Nursing from "@/public/key-workers/nurses.svg?url";
import Education from "@/public/key-workers/education.svg?url";
import FireBrigade from "@/public/key-workers/fire-brigade.svg?url";
import PolicePrisons from "@/public/key-workers/police.svg?url";
import Government from "@/public/key-workers/government.svg?url";

const KeyWorkers = (): JSX.Element => {
  return (
    <section className="px-4 pt-12 pb-9 bg-white md:px-6 lg:px-0">
      <h3 className="mb-5 text-3xl font-bold lg:text-5xl text-landing-blue md:mb-3 lg:mb-5 xt-left text-center">
        Providing keys to Key Workers
      </h3>
      <h4 className="mb-5 font-serif text-xl text-left lg:text-3xl text-landing-blue lg:mb-14 text-center">
        Keyzy is here to help those who keep the country running.
      </h4>

      <div className="block lg:h-[422px] lg:flex lg:flex-row lg:justify-center lg:mb-11">
        <Card
          title="Healthcare Professionals"
          size="big"
          image={Medical}
          subtitle={
            "Healthcare professionals in the NHS and private sector play a critical role keeping the UK population healthy."
          }
        />

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block " />

        <Card
          title="Nursing and Social Care"
          size="big"
          image={Nursing}
          subtitle={
            "Nurses and Social Care workers provide critical care services to care for those in need."
          }
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="Teachers and Education Sector"
          size="big"
          image={Education}
          subtitle={
            "Every young person and adult in the UK had or currently depends on education workers to help them grow."
          }
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
      </div>

      <HorizontalBar className="hidden w-auto mx-20 lg:flex mb-11" />

      <div className="block lg:h-[422px] lg:flex lg:justify-center lg:flex-row lg:mb-11">
        <Card
          title="Fire Brigade"
          size="big"
          image={FireBrigade}
          subtitle={
            "Fire and rescue services across the UK protect life and property when we need it most."
          }
        />

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="Police and Prisons"
          size="big"
          image={PolicePrisons}
          subtitle={
            "Our prisons and police services are an essential part of Britain’s criminal justice system."
          }
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="Government Services"
          size="big"
          image={Government}
          subtitle={
            "The country runs through our Critical National Infrastructure including Defence, Transport, Food and Energy."
          }
        />
      </div>
      <div className="left-0 right-0 m overflow-hidden bg-repeat-x h-24 md:h-32 xl:h-48 bg-[url('/key-workers/city-outline-mobile.svg')]  md:bg-[url('/key-workers/city-outline-tablet.svg')] xl:bg-[url('/key-workers/city-outline-desktop.svg')]" />
    </section>
  );
};

export default KeyWorkers;
